import { useMemo } from 'react';
import { generateQrMatrix } from '../lib/qr';

interface Props {
  value: string;
  size?: number;
  color?: string;
  background?: string;
}

export function QrCode({ value, size = 180, color = '#1f1f1f', background = '#ffffff' }: Props) {
  const matrix = useMemo(() => generateQrMatrix(value), [value]);
  const n = matrix.length;
  const cell = size / n;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${n} ${n}`}
      role="img"
      aria-label={`QR code for ${value}`}
      shapeRendering="crispEdges"
      style={{ display: 'block' }}
    >
      <rect x={0} y={0} width={n} height={n} fill={background} />
      {matrix.map((row, y) =>
        row.map((v, x) =>
          v ? <rect key={`${x}-${y}`} x={x} y={y} width={1.02} height={1.02} fill={color} /> : null,
        ),
      )}
    </svg>
  );
}
